import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { CommunityBoardApi } from 'api/community/CommunityBoardApi';
import { NoticeProvider } from './context';

const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const NoticeBoardConfig = {
    routes: [
        {
            path: 'notice',
            children: [
                {
                    path: '',
                    element: <NoticeProvider><List /></NoticeProvider>
                },
                {
                    path: 'create',
                    element: <NoticeProvider><Create /></NoticeProvider>
                },
                {
                    path: 'modify/:code',
                    element: <NoticeProvider><Edit /></NoticeProvider>
                }
            ]
        }
    ],
    API: CommunityBoardApi
};

export default NoticeBoardConfig;
